export default "__VITE_ASSET__Cq4SXJWG__"